import { FC, useCallback, useState } from 'react'
import AddItem from '../components/AddItem'
import Resources from '../components/Resources'
import ScreenWrapper from '../components/ScreenWrapper'
import {
    useDeleteMeasurementIdMeasurement,
    useGetMeasurement,
    usePutMeasurementIdMeasurement
} from '../generated/apiData'
import { Measurement } from '../generated/types'
import { formatDateTimeLocal } from '../utils/formatDateTimeLocal'


type ListProps = {
    item: Measurement
}

const meals: Record<number, string> = {
    0: 'Voor ontbijt',
    1: 'Na ontbijt',
    2: 'Na lunch',
    3: 'Na avondeten'
}

const ListListItem: FC<ListProps> = ({item}) => {
    const [edit, setEdit] = useState(false)
    const [value, setValue] = useState<number>(item.Value)
    const [meal, setMeal] = useState<number>(item.Meal)
    const [timeDifference, setTimeDifference] = useState<number>(item.TimeDifference)
    const [measured, setMeasured] = useState<string>(formatDateTimeLocal(new Date(item.Measured)))
    const [remarks, setRemarks] = useState<string>(
        item.Remarks ?? '',
    )
    const params = {
        idMeasurement: item.idMeasurement,
    }
    const {perform: performPut} = usePutMeasurementIdMeasurement(params)
    const {perform: performDelete} = useDeleteMeasurementIdMeasurement(params)
    const onClick = useCallback(() => setEdit(true), [])
    const onSave = () => {
        void performPut(
            {},
            {
                ...item,
                Value: value,
                Measured: new Date(measured).toJSON(),
                Remarks: remarks,
            },
        )
    }
    const onSubmit = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.code === 'NumpadEnter' || event.code === 'Enter') {
            onSave()
        }
    }
    if (edit) {
        return (
            <>
                <td>
                    <input
                        onChange={({target: {value}}) => setValue(+value)}
                        onKeyUp={onSubmit}
                        type="number"
                        step="0.1"
                        value={value}
                    />
                    <button onClick={onSave}>Save</button>
                </td>
                <td>
                    <select
                        onChange={({target: {value}}) => setMeal(+value)}
                        value={meal}>
                            <option value={0}>Voor ontbijt</option>
                            <option value={1}>Na ontbijt</option>
                            <option value={2}>Na lunch</option>
                            <option value={3}>Na avondeten</option>
                            </select>
                    <button onClick={onSave}>Save</button>
                </td>
                <td>
                    <select
                        onChange={({target: {value}}) => setTimeDifference(+value)}
                        value={meal}>
                            <option value={0}>0 uur</option>
                            <option value={1}>1 uur</option>
                            <option value={2}>2 uur</option>
                    </select>
                    <button onClick={onSave}>Save</button>
                </td>
                <td>
                    <textarea
                        onChange={({target: {value}}) => setRemarks(value)}
                        value={remarks}/>
                    <button onClick={onSave}>Save</button>
                </td>
                <td>
                    <input
                        onChange={e => setMeasured(e.target.value)}
                        onKeyUp={onSubmit}
                        type="datetime-local"
                        value={measured}
                    />
                    <button onClick={onSave}>Save</button>
                </td>
                <td>
                    <button onClick={() => {
                        if (confirm('Weet je zeker dat je deze waarde wilt verwijderen')) {
                            void performDelete()
                        }
                    }}>Verwijder</button>
                </td>
            </>
        )
    }
    return (
        <>
            <td onClick={onClick}>{value ?? ''}</td>
            <td onClick={onClick}>{meals[meal] ?? ''}</td>
            <td onClick={onClick}>{timeDifference > 0 ? `${timeDifference} uur`: ''}</td>
            <td onClick={onClick}>{remarks ?? ''}</td>
            <td onClick={onClick}>{new Date(measured).toLocaleString() ?? ''}</td>
            <td>
                <button onClick={() => {
                    if (confirm('Weet je zeker dat je deze waarde wilt verwijderen')) {
                        void performDelete()
                    }
                }}>Verwijder</button>
            </td>
        </>
    )
}

const ListScreen: FC = () => {
    return (
        <ScreenWrapper
            title={'Metingen'}
            backURL={`/lists`}>
            <Resources
                RenderListItem={ListListItem}
                keyExtractor={item => item.idMeasurement?.toString(10) ?? ''}
                useGetEndpoint={useGetMeasurement}
                resourceName="item"
                ItemContainerElement="tr"
                ItemsContainer={({children}) => (
                    <table>
                        <thead>
                            <tr>
                                <th>Waarde</th>
                                <th>Maaltijd</th>
                                <th>Tijdsverschil</th>
                                <th>Opmerking</th>
                                <th>Wanneer</th>
                                <th>Verwijder</th>
                            </tr>
                        </thead>
                        {children}
                    </table>
                )}
                sort={(a,b) => new Date(b.Measured).getTime() - new Date(a.Measured).getTime()}
            />
            <h2>Nieuwe meting invoeren</h2>
            <AddItem />
        </ScreenWrapper>
    )
}

export default ListScreen
